import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LANGUAGES } from "../../constants";
import { LanguageDirection } from "../../utility/LanguageDirection";
import Text from "../Text/Text";
import Title from "../Title/Title";
import "./SelectLanguage.css";
import {useSelector} from "react-redux";



// const CustomOption = ({ children, ...props }) => {
//   // You can customize the appearance and behavior of the custom option here

//   return (
//     <components.Option {...props}>
//       {/* <div className="list"> */}
//         <Link to={`/login`}>
//           <img  draggable={false} src={props.data.name == "arabic" ? arabic : english} alt="" />
//           <span className={props.data.name}>{props.data.label}</span>
//         </Link>
//       {/* </div> */}
//     </components.Option >
//   );
// };



const SelectLanguage = () => {

  const { i18n, t } = useTranslation();
  const direction = LanguageDirection();
  const navigate = useNavigate();
  const {user} = useSelector(state => state.authData);

  const onChangeLang = (code) => {
    i18n?.changeLanguage(code);
  };

  // const [options, setOptions] = useState(LANGUAGES);

  const handleSelectChange = (selectedOption) => {
      navigate('/login')
    onChangeLang(selectedOption.code)
  };


  useEffect(() => {
    if(user){
        navigate('/home/reward')
    }
  }, [user, navigate]);


  return (
    <section className={`select-language ${direction === 'rtl' && ('rtl')}`}>
      <div className="select-language-content">
        <Title className="text-20">{t("selectLanguage.title")}</Title>
        <Text>{t("selectLanguage.text")}</Text>

        <div className="select-languages">
          {/* <ul>
            {LANGUAGES.map(({ code, label, name }) => (
              <li>
                <Link to={`/login`} onClick={() => onChangeLang(code)}>
                  <img  draggable={false} src={name == "arabic" ? arabic : english} alt="" />
                  <span className={name}>{label}</span>
                </Link>
              </li>
            ))}
          </ul> */}
            {LANGUAGES.map((item, index) =>
                <div dir={direction === 'rtl' && 'rtl'} onClick={() => handleSelectChange(item)} key={index} >
                    <img className="select-lang-img" draggable={false} src={item.logo} alt="" />
                    <span className={item.name}>{item.label}</span>
                </div>
            )}

{/*
          <Select
            value={selectedOption}
            onChange={handleSelectChange}
            options={LANGUAGES}
            components={{ Option: CustomOption }}
            isSearchable
            placeholder={t("selectLanguage.placeholder")}
            styles={customStyles}
          /> */}

        </div>
      </div>
    </section>
  );
};

export default SelectLanguage;
